import factory from "../../Images/factory.png";
import value from "../../Images/value.png";
import vision from "../../Images/vision.png";
import goal from "../../Images/goal.png";
import clinicalSuppliest from "../../Images/clinical-suppliest.png";
import cooperation from "../../Images/cooperation.png";
import drug from "../../Images/drug-sourcing.png";
import folders from "../../Images/folders.png";
import formulate from "../../Images/formulate.png";
import microscope from "../../Images/microscope.png";
import molecules from "../../Images/molecules.png";
import nanomedicine from "../../Images/nanomedicine.png";
import supplies from "../../Images/supplies.png";
import trial from "../../Images/trial-supplies.png";
import why from "../../Images/why-1.png";
import reactor from "../../Images/reactor.jpg";
import P1 from "../../Images/P1.jpeg";
import P2 from "../../Images/P2.jpeg";
import { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

export function Home() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [errorMessage, setErrorMessage] = useState("");

  const validateForm = () => {
    const newErrors = {};

    if (formData.name.trim() === "") {
      newErrors.name = "Name is required";
    }

    if (
      !/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
        formData.email
      )
    ) {
      newErrors.email = "Invalid email address";
    }

    if (!/^[0-9]{10}$/.test(formData.phone)) {
      newErrors.phone = "Phone must be 10 digits long and contain only numbers";
    }

    if (formData.message.trim() === "") {
      newErrors.message = "Message is required";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      setErrorMessage("Please correct the errors in the form.");
      return false; // Prevent form submission
    } else {
      setErrors({});
      setErrorMessage("");
      return true; // Allow form submission
    }
  };

  const handleEmail = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      var data = {
        email: formData.email,
        phone: formData.phone,
        city: formData.city,
        name: formData.name,
        message: formData.message,
      };
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          access_key: "1ad7861f-67fb-48c3-9c4e-bf6c30d95715",
          ...data,
        }),
      });
      if (response.ok) {
        alert("Email sent");
      } else {
        alert("Oops... Something Went Wrong ");
      }
    }
  };

  return (
    <>
      <div
        id="carouselExampleIndicators"
        className="carousel slide"
        data-ride="carousel"
      >
        <div className="carousel-inner">
          <div className="carousel-item active">
            <img className="d-block w-100" src={P1} alt="First slide" />
          </div>
          <div className="carousel-item">
            <img className="d-block w-100" src={P2} alt="Second slide" />
          </div>
        </div>
        <a
          className="carousel-control-prev"
          href="#carouselExampleIndicators"
          role="button"
          data-slide="prev"
        >
          <span
            className="carousel-control-prev-icon"
            aria-hidden="true"
          ></span>
          <span className="sr-only">Previous</span>
        </a>
        <a
          className="carousel-control-next"
          href="#carouselExampleIndicators"
          role="button"
          data-slide="next"
        >
          <span
            className="carousel-control-next-icon"
            aria-hidden="true"
          ></span>
          <span className="sr-only">Next</span>
        </a>
      </div>
      <section className="call-to-action-wrap-layout5 bg-light-secondary100">
        <div className="container">
          <div className="row">
            <div className="col-md-4 col-12 single-item">
              <div className="call-to-action-box-layout5">
                <div className="media media-none-md">
                  <i>
                    {" "}
                    <img
                      src={factory}
                      className="img-fluid img-factory"
                      alt="Krufren Pharma"
                      style={{ width: "60px", height: "60px" }}
                    />{" "}
                  </i>
                  <div className="media-body box-content">
                    <h4 className="item-title">manufacturer of API</h4>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4 col-12 single-item">
              <div className="call-to-action-box-layout5">
                <div className="media media-none-md">
                  <i>
                    {" "}
                    <i className="bi bi-person-standing"></i>
                  </i>
                  <div className="media-body box-content">
                    <h4 className="item-title">50+ Employee</h4>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4 col-12 single-item">
              <div className="call-to-action-box-layout5">
                <div className="media media-none-md">
                  <i className="bi bi-flag-fill"></i>
                  <div className="media-body">
                    <h4 className="item-title"> Founded In 2015 </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="about-wrap-layout1">
        <div className="container">
          <div className="row">
            <div className="about-box-layout2 order-xl-1 col-xl-6 col-lg-6 col-12">
              <div className="image-block">
                <div
                  className="image-one wow fadeInLeft"
                  data-wow-delay="0ms"
                  data-wow-duration="1500ms"
                  style={{
                    visibility: "visible",
                    animationDuration: "1500ms",
                    animationDelay: "0ms",
                    animationName: "fadeInLeft",
                  }}
                >
                  <div className="image-box">
                    <img
                      className="lazy-image owl-lazy loaded"
                      src={reactor}
                      data-src="images/resource/image-5.jpg"
                      alt="Darshak"
                      data-was-processed="true"
                      data-no-retina=""
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="about-box-layout1 order-xl-2 col-xl-6 col-12 col-lg-6">
              <div className="item-content">
                <h2 className="item-title"> Welcome to Krufren Pharma</h2>
                <p>
                  Krufren Pharma is a trusted R&D and manufacturing partner that
                  transforms your ideas into solutions, keeping you ahead in the
                  race for better health. The products of Acuvits target various
                  therapeutic applications, including gastrointestinal,
                  cardiovascular, women's healthcare, respiratory, pain
                  management, central nervous system, anti-tissue diseases
                  related to neurology, dermatology, and nephrology.{" "}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="features pt-120 pb-90">
        <div className="container">
          <div className="row section-title">
            {/* Content for the section-title */}
          </div>
          <div className="row">
            <div className="col-md-4">
              <div className="feat-item-one">
                <div className="content-box-feat">
                  <span className="flaticon-thinking">
                    <img src={goal} alt="Goal" />
                  </span>
                  <h4>Our Mission</h4>
                  <p>
                    Whether large pharma or small biotech, small or large
                    molecule, a single service need or an end-to-end solution,
                    we give complete attention to each customer, offering a
                    reliable and seamless experience. Leveraging our innovation
                    mindset, rich scientific talent, and empowered teams, we
                    consistently deliver value to our customers.{" "}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="feat-item-one">
                <div className="content-box-feat">
                  <span className="flaticon-idea">
                    <img src={vision} alt="Vision" />
                  </span>
                  <h4>Our Vision</h4>
                  <p>
                    Empowering Health Through Excellence in API Manufacturing:
                    Our vision is to lead the way in API manufacturing, driving
                    innovation, and setting the highest quality standards in the
                    pharmaceutical industry. We are committed to advancing
                    global healthcare by consistently delivering safe,
                    affordable, and high-quality APIs.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4 h-100">
              <div className="feat-item-one">
                <div className="content-box-feat">
                  <span className="flaticon-book">
                    <img src={value} alt="Value Proposal" />
                  </span>
                  <h4>Our Value</h4>
                  <p>
                    Our values, which we call ETHICS, guide our decisions,
                    express our beliefs, and define our culture. They are a
                    deeply embedded code of conduct that we live by every day.
                    From leadership to staff, the values embedded in our ETHICS
                    determine 'how we do what we do' for our customers, for each
                    other, and for every stakeholder at Krufren Pharma.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section className="departments-wrap-layout2 bg-light-secondary100">
        <div className="container">
          <div className="section-heading heading-dark text-center heading-layout1">
            <h2>What We Do</h2>
          </div>
          <div className="row">
            <div className="col-md-4">
              <div className="what-block">
                <img src={drug} alt="" className="img-fluid" />
                <h3>R&D</h3>
                <ul>
                  <li>
                    <i className="fa fa-check"></i> Contract Research
                  </li>
                  <li>
                    <i className="fa fa-check"></i> Research Development
                    Chemistry
                  </li>
                  <li>
                    <i className="fa fa-check"></i> Research Development
                    Technology
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md-4">
              <div className="what-block">
                <img src={trial} alt="" className="img-fluid" />
                <h3>Advance Intermideate</h3>
                <ul>
                  <li>
                    <i className="fa fa-check"></i> Speciality Chemical
                  </li>
                  <li>
                    <i className="fa fa-check"></i> Intermideate
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md-4">
              <div className="what-block">
                <img src={clinicalSuppliest} alt="" className="img-fluid" />
                <h3>Export</h3>
                <ul>
                  <li>
                    <i className="fa fa-check"></i> Active Pharmaceutical
                    Ingredients (API)
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="features pt-120 pb-90">
        <div
          className="section-heading heading-dark text-center heading-layout1"
          style={{ marginTop: "50px" }}
        >
          <h2>Why Choose Us</h2>
        </div>
        <div className="container">
          <div className="row section-title">
            {/* Content for the section-title */}
          </div>
          <div className="row">
            <div className="col-sm-6 col-lg-3">
              <div className="feat-item-one">
                <div className="content-box-feat">
                  <img src={why} alt="Api facility" />
                  <h4>Api facility with capacity up to 150 tpa</h4>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-lg-3">
              <div className="feat-item-one">
                <div className="content-box-feat">
                  <img src={supplies} alt="Commercial Supplies" />
                  <h4>Commercial Supplies across the globe</h4>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-lg-3">
              <div className="feat-item-one">
                <div className="content-box-feat">
                  <img src={molecules} alt="Molecules under Development" />
                  <h4>15+ Molecules under Development</h4>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-lg-3">
              <div className="feat-item-one">
                <div className="content-box-feat">
                  <img src={folders} alt="DMF & ANDA Available" />
                  <h4>DMF will be submitted in near future</h4>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-lg-3">
              <div className="feat-item-one">
                <div className="content-box-feat">
                  <img src={cooperation} alt="Business Associates" />
                  <h4>Open To Consider Dynamic Business Associates </h4>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-lg-3">
              <div className="feat-item-one">
                <div className="content-box-feat">
                  <img
                    src={formulate}
                    alt="Manufacturing Of API & Formulations"
                  />
                  <h4>
                    Manufacturing Of Speciality Chemical, Advance Intermideate,
                    and API
                  </h4>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-lg-3">
              <div className="feat-item-one">
                <div className="content-box-feat">
                  <img src={nanomedicine} alt="Drug development expertise" />
                  <h4>Research Expertise in Complex Molecule</h4>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-lg-3">
              <div className="feat-item-one">
                <div className="content-box-feat">
                  <img src={microscope} alt="Development And Research" />
                  <h4>Development And Research</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section className="call-to-action-wrap-layout4">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xl-6 col-lg-6 col-md-6 col-12">
              <div className="call-to-action-box-layout4">
                <h2 className="item-title">
                  We Provide the highest level of satisfaction care & services
                  to our Customer.
                </h2>
                <div className="call-to-action-btn">
                  <Link to="contact" className="item-btn">
                    Contact Us
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="appointment-box-layout1">
                <h2 className="title title-bar-primary2">Send Enquiry</h2>
                <form
                  onSubmit={handleEmail}
                  className="contact-form-box"
                  id="contact-form"
                >
                  <div className="row">
                    <div className="col-md-12 form-group">
                      <input
                        type="text"
                        placeholder="First Name *"
                        className="form-control"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={(e) =>
                          setFormData({ ...formData, name: e.target.value })
                        }
                        required
                      />
                      {errors.name && (
                        <span className="error">{errors.name}</span>
                      )}
                    </div>
                    <div className="col-md-6 form-group">
                      <input
                        type="email"
                        placeholder="E-mail *"
                        className="form-control"
                        name="email"
                        id="email"
                        value={formData.email}
                        onChange={(e) =>
                          setFormData({ ...formData, email: e.target.value })
                        }
                        required
                      />
                      {errors.email && (
                        <span className="error">{errors.email}</span>
                      )}
                    </div>
                    <div className="col-md-6 form-group">
                      <input
                        type="text"
                        placeholder="Phone *"
                        className="form-control"
                        name="phone"
                        id="phone"
                        value={formData.phone}
                        onChange={(e) =>
                          setFormData({ ...formData, phone: e.target.value })
                        }
                        required
                      />
                      {errors.phone && (
                        <span className="error">{errors.phone}</span>
                      )}
                    </div>
                    <div className="col-12 form-group">
                      <textarea
                        placeholder="Message*"
                        className="textarea form-control"
                        name="message"
                        id="message"
                        value={formData.message}
                        onChange={(e) =>
                          setFormData({ ...formData, message: e.target.value })
                        }
                        rows="7"
                        cols="20"
                        required
                      ></textarea>
                      {errors.message && (
                        <span className="error">{errors.message}</span>
                      )}
                    </div>
                    <div className="col-12 form-group"></div>
                    <div className="col-12 form-group margin-b-none">
                      {errorMessage && <p className="error">{errorMessage}</p>}
                      <button type="submit" className="item-btn">
                        Submit Message
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
